export default "__VITE_ASSET__cfc6dce4__"